import { useNotificationStore } from '@/stores/notificationstore';
import { useTranslation } from 'react-i18next';
import { LocalMessage } from 'stream-chat';
import { MessageList, useChatContext } from 'stream-chat-react';

export default function CustomMessageList() {
  const { channel } = useChatContext();
  const { t } = useTranslation();
  const showNotification = useNotificationStore((state) => state.showNotification);

  const messageActions = {
    [t('streamChat.custom.readBy')]: (message: LocalMessage) => {
      const readSTate = channel?.state.read;
      if (!readSTate) {
        return;
      }
      const creatorId = message.user?.id;
      const createdAt = message.created_at;
      const readUsers = [];
      for (const [userId, status] of Object.entries(readSTate)) {
        const lastRead = status.last_read;
        if (creatorId !== userId && createdAt.getTime() < lastRead.getTime()) {
          readUsers.push(status.user.name);
        }
      }
      if (!readUsers.length) {
        showNotification('info', t('streamChat.custom.noneRead'), undefined, 5);
        return;
      }
      const notification = [t('streamChat.custom.readBy'), ...readUsers].join('\n');
      showNotification('info', notification);
    },
  };
  return <MessageList customMessageActions={messageActions} />;
}
